import { SeriesRegistrantList } from '@goldcast/api/backend';

import { State } from './types';

const mutations = {
  setSeriesRegistrants(state: State, seriesRegistrants: SeriesRegistrantList[]) {
    state.seriesRegistrants = seriesRegistrants;
  },
  setSeriesRegistrantSearchTerm(state: State, seriesRegistrantsSearchTerm: string) {
    state.seriesRegistrantsSearchTerm = seriesRegistrantsSearchTerm;
  },
  setToggleSelectSeriesRegistrant(state: State, { seriesRegistrant }: { seriesRegistrant: SeriesRegistrantList }) {
    if (!seriesRegistrant?.id || state.isAllSelected) {
      return;
    }

    const isRegistrantSelected = !!state.seriesSelectedRegistrants[seriesRegistrant.id];
    if (isRegistrantSelected) {
      delete state.seriesSelectedRegistrants[seriesRegistrant.id];
    } else {
      state.seriesSelectedRegistrants[seriesRegistrant.id] = seriesRegistrant;
    }
  },
  setToggleSelectAllSeriesRegistrants(state: State, selected?: boolean) {
    if (selected !== undefined) {
      state.isAllSelected = selected;
    } else {
      state.isAllSelected = !state.isAllSelected;
    }

    if (!state.isAllSelected) {
      state.seriesSelectedRegistrants = {};
    }
  },
  setIsSeriesRegistrantsLoading(state: State, isSeriesRegistrantsLoading: boolean) {
    state.isSeriesRegistrantsLoading = isSeriesRegistrantsLoading;
  },
  setSeriesRegistrantsCurrentPage(state: State, seriesRegistrantsCurrentPage: number) {
    state.seriesRegistrantsCurrentPage = seriesRegistrantsCurrentPage;
  },
  setSeriesRegistrantsCount(state: State, seriesRegistrantsCount: number) {
    state.seriesRegistrantsCount = seriesRegistrantsCount;
  },
  clearSelectedColumnFilters(state: State, columnKey: string) {
    state.uniqueColumnFilters[columnKey] = [];
  },
  clearAllSelectedFilters(state: State) {
    Object.keys(state.uniqueColumnFilters).forEach(key => {
      const updatedFilterItems: Record<string, string | boolean>[] = [];

      state.uniqueColumnFilters[key].forEach(filterItem => {
        const updatedFilterItem = {
          ...filterItem,
          selected: false
        };
        updatedFilterItems.push(updatedFilterItem);
      });

      state.uniqueColumnFilters[key] = updatedFilterItems;
    });
  },
  setColumnsFiltersSearchTerms(state: State, { key, value }: { key: string; value: string }) {
    state.columnsFiltersSearchTerms[key] = value;
  },
  toggleSelectUniqueColumnFilter(state: State, { key, id }: { key: string; id: string }) {
    const colFilters = state.uniqueColumnFilters[key] || [];

    const colFilterItemIdx = colFilters.findIndex(colFilter => colFilter.id == id);

    if (colFilterItemIdx > -1) {
      const updatedColFilterItem = {
        ...colFilters[colFilterItemIdx],
        selected: !colFilters[colFilterItemIdx].selected
      };

      state.uniqueColumnFilters[key][colFilterItemIdx] = updatedColFilterItem;
    }
  },
  setUniqueColumnFilters(
    state: State,
    { key, uniqueFilters }: { key: string; uniqueFilters: Record<string, string | boolean>[] }
  ) {
    if (!state.uniqueColumnFilters[key]) {
      state.uniqueColumnFilters[key] = [];
    }

    state.uniqueColumnFilters[key] = uniqueFilters;
  },
  resetUniqueColumnFilters(state: State) {
    state.uniqueColumnFilters = {};
  },
  setColumnFilter(state: State, { key, value }: { key: string; value: boolean }) {
    const column = state.columns.find(column => column.key === key);

    if (!column) {
      return;
    }

    column.isFilterOpen = value;
  },
  setColumnOrderBy(state: State, { orderBy: newOrderBy }: { orderBy: string }) {
    if (state.orderBy?.includes(newOrderBy)) {
      state.orderBy = state.orderBy?.startsWith('-') ? newOrderBy : `-${newOrderBy}`;
    } else {
      state.orderBy = newOrderBy;
    }
  }
};

export default mutations;
